<template>
    <div class="bg-primary w-full p-3  flex justify-center items-center">
        <div class="w-1/3 lg:w-1/12 ">
            <div class="mx-auto w-4/6 flex justify-center items-center">
                <Logo ></Logo>

            </div>
        </div>
    </div>
</template>

<script setup>
import Logo from './Logo.vue';

</script>